const getInitiatorParticipantTypeCookieName = (incidentKey: string, partyKey: string): string => `lkfls_participant_type_${incidentKey}_${partyKey}`;

export default getInitiatorParticipantTypeCookieName;
